var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { stringify } from 'query-string';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiGetListProffitSearchFolder } from '../../../../actions/ProffitSearchFolderAction';
import { wrapDispatch } from '../../../../helpers/action';
import { getUserMode } from '../../../../helpers/auth';
import { parseQueryString } from '../../../../helpers/common/QueryStringHelper';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../../helpers/profile';
import { compose } from '../../../../helpers/recompose';
import { useSlideSearchLockItem } from '../../../../helpers/use/proffit_search/common/useSlideSearchLockItem';
import { useMyPageFolder } from '../../../../helpers/use/proffit_search/mypage/useMyPageFolder';
import { useUnmountRef } from '../../../../helpers/use/useHook';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchRegistrationDeviceHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import AddFolderModal from '../../../Ui/SlideSearch/Modal/AddFolderModal';
import SlideAddButton from '../../Common/Action/Button/SlideAddButton';
import SlideSearchRegistrationModals from '../../Common/Modal/SlideSearchRegistrationModals';
import ProffitSearchTab from './Parts/Common/ProffitSearchTab/ProffitSearchTab';
import FolderFilter from './Parts/MyFolder/FolderFilter/FolderFilter';
import FolderTable from './Parts/MyFolder/FolderTable/FolderTable';
const MyFolderInner = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const profile = useSelector((state) => state.profile);
    const auth = useSelector((state) => state.auth);
    const userMode = getUserMode(auth);
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            text: 'フォルダ',
        },
    ], []);
    const folderNamePopperOptions = useMemo(() => ({
        modifiers: [
            {
                enabled: true,
                fn(data) {
                    data.instance.popper.classList.add('slide_search_mypage_folder_name_tooltip');
                    return data;
                },
                name: 'addClassName',
            },
        ],
    }), []);
    const { pathname, search } = useLocation();
    const key = 'dummy';
    const [loadingMap, changeLoading] = useState({});
    const [dataMap, changeData] = useState({});
    const { formatQuery, query } = useMemo(() => parseQueryString(search, [
        { initial: '', name: 'searchText', type: 'string' },
    ]), [search]);
    const loadFolders = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading((prev) => (Object.assign(Object.assign({}, prev), { [key]: true })));
        const { payload } = yield wrapDispatch(dispatch, apiGetListProffitSearchFolder({
            keyword: formatQuery.searchText,
        }));
        const { list } = payload;
        if (unmountRef.current) {
            return;
        }
        changeData((prev) => (Object.assign(Object.assign({}, prev), { [key]: list })));
        changeLoading((prev) => (Object.assign(Object.assign({}, prev), { [key]: false })));
    }), [
        dispatch,
        key,
        unmountRef,
        changeData,
        changeLoading,
        formatQuery.searchText,
    ]);
    useEffect(() => {
        // api実行
        loadFolders().then();
    }, [loadFolders]);
    const { addModalState, hideAddModal, initialValues: folderInitialValues, onClickSort, onSubmitCreateFolder, order, rows, showAddModal, sort, } = useMyPageFolder.useEvent(dispatch, dataMap[key], loadFolders);
    const onClickRow = useCallback((e) => {
        const { dataset } = e.currentTarget;
        const { folder_id: folderId } = dataset;
        history.push(`/proffit_search/folder/${folderId}`);
    }, [history]);
    const onBlurKeyword = useCallback((e) => {
        const searchText = e.currentTarget.value;
        const newQuery = stringify(Object.assign(Object.assign({}, query), { searchText }));
        history.replace(`${pathname}?${newQuery}`);
    }, [history, pathname, query]);
    const { canRegistrationTrial, plan, unReadSlideCount } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const isFree = isProffitSearchFreePlan(plan);
    const { email, hideCompleteModal, hideFormModal, hidePaidModal, initialValues, isShowCompleteModal, isShowFormModal, isShowPaidModal, kanaRef, onClickLockItem, onSubmitRegistration, } = useSlideSearchLockItem.useSlideSearchLockItemModal(profile, userMode, dispatch, unmountRef);
    return (_jsxs(Layout, Object.assign({ headerType: 'proffit_search', mainClassName: 'l-main slide_search_page slide_search_mypage_folder_page', sticky: _jsx(SlideAddButton, { disabled: isFree, onClickLockItem: onClickLockItem }), stickyClassName: 'slide_search_page' }, { children: [_jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(Breadcrumb, { lists: pans }), _jsx("div", Object.assign({ className: 'mypage_container' }, { children: _jsxs("div", Object.assign({ className: 'mypage_content' }, { children: [_jsx(ProffitSearchTab, { active: 'folder', rightColumn: _jsx(FolderFilter, { defaultKeywordValue: formatQuery.searchText, onBlurKeyword: onBlurKeyword }), unReadReceiveCount: unReadSlideCount }), _jsxs("div", Object.assign({ className: 'proffit_search_folder_action' }, { children: [!loadingMap[key] &&
                                            rows.length === 0 &&
                                            formatQuery.searchText === '' && (_jsxs("div", Object.assign({ className: 'proffit_search_folder_empty_description' }, { children: ["\u307E\u3060\u30D5\u30A9\u30EB\u30C0\u304C\u3042\u308A\u307E\u305B\u3093", _jsx("br", {}), "\u65B0\u3057\u3044\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044"] }))), _jsx("button", Object.assign({ className: 'action_button button service', onClick: showAddModal, type: 'button' }, { children: "\u65B0\u3057\u3044\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210" }))] })), _jsx("div", Object.assign({ className: 'proffit_search_table_box' }, { children: _jsx(FolderTable, { folderNamePopperOptions: folderNamePopperOptions, loading: !!loadingMap[key], onClickRow: onClickRow, onClickSort: onClickSort, order: order, rows: rows, searchText: formatQuery.searchText, sort: sort }) }))] })) }))] })), _jsx(AddFolderModal, { hideModal: hideAddModal, initialValues: folderInitialValues, isShow: addModalState, onSubmit: onSubmitCreateFolder }), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: email, hideCompleteModal: hideCompleteModal, hideFormModal: hideFormModal, hidePaidModal: hidePaidModal, initialValues: initialValues, isShowCompleteModal: isShowCompleteModal, isShowFormModal: isShowFormModal, isShowPaidModal: isShowPaidModal, kanaRef: kanaRef, onSubmitRegistration: onSubmitRegistration, userMode: userMode })] })));
};
const MyFolder = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchRegistrationDeviceHoc(), ProffitSearchTutorialHoc())(MyFolderInner);
export default MyFolder;
